/* eslint-disable implicit-arrow-linebreak */
import { useMutation } from '@tanstack/react-query';
import { AlertAdapter } from 'pg-ui-library';
import SettingsService from 'src/services/settings.service';

export const usePatchSettings = () => {
  const mutation = useMutation(
    (data: { id: string; value: boolean }) => SettingsService.patchSettings({ id: data.id }),
    {
      onSuccess: () => {
        AlertAdapter('Config changed successfully', 'success');
      },
      onError: () => {
        AlertAdapter('Failed to edit config', 'error');
      },
    }
  );
  return mutation;
};
